import { getSearchResultsListId } from 'features/search/helpers';
import { useList } from 'features/lists/hooks/useList';

export const useArtworksSearchResults = (query: string) => {
  const listId = getSearchResultsListId(query, 'artworks');
  const results = useList(listId, (state) => state.artworks.byId);

  return results;
};
